import { render } from "./HomeMain.vue?vue&type=template&id=5e6bcf2b&scoped=true"
import script from "./HomeMain.vue?vue&type=script&lang=js"
export * from "./HomeMain.vue?vue&type=script&lang=js"

import "./HomeMain.vue?vue&type=style&index=0&id=5e6bcf2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6bcf2b"]])

export default __exports__